import {
  BarChart3,
  Building2,
  Clock,
  FileDown,
  HardHat,
  LayoutDashboard,
  ScrollText,
  Settings,
  CreditCard,
  Tractor,
  Users,
  UsersRound,
  Wallet,
  type LucideIcon,
} from "lucide-react";

export interface NavItem {
  to: string;
  label: string;
  icon: LucideIcon;
  end?: boolean;
  mobile?: boolean;
}

export const NAV_ITEMS: NavItem[] = [
  { to: "/dashboard", label: "Command", icon: LayoutDashboard, end: true, mobile: true },
  { to: "/sites", label: "Sites", icon: Building2, mobile: true },
  { to: "/daily-entry", label: "Field Entry", icon: Clock, mobile: true },
  { to: "/equipment", label: "Equipment", icon: Tractor, mobile: true },
  { to: "/pay-periods", label: "Pay Periods", icon: HardHat, mobile: true },
  { to: "/exports", label: "Exports", icon: FileDown, mobile: true },
  { to: "/reports", label: "Reports", icon: BarChart3 },
  { to: "/workers", label: "Workers", icon: Users },
  { to: "/crews", label: "Crews", icon: UsersRound },
  { to: "/pay-rules", label: "Pay Rules", icon: Wallet },
  { to: "/billing", label: "Billing", icon: CreditCard },
  { to: "/audit-log", label: "Audit Trail", icon: ScrollText },
  { to: "/settings", label: "Settings", icon: Settings },
];

export const MOBILE_NAV_ITEMS = NAV_ITEMS.filter((item) => item.mobile);
